/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.directive('street', function ($q, $http, $timeout) {
	return {
		restrict: 'E',
		scope: {
			tCounty: '=',
			tComunity: '=',
			tModel: '=',
			tState: '='
		},
		templateUrl: "/assets/js/angular/components/directives/teryt/types/street.html",
		link: function (scope) {
			scope.cities = {
				list: [],
				item: null,
				text: null
			};

			scope.required = typeof scope.tModel.required == 'undefined'?false:scope.tModel.required;

			scope.disabled = true;
			scope.$watch('tComunity', function () {
				scope.disabled = true;
				scope.cities.list = [];
				scope.cities.text = null;
				if (!_.isUndefined(scope.tComunity) && !_.isNull(scope.tComunity)) {
					if (!_.isNull(scope.tComunity.name)) {
						scope.disabled = false;
					}
				}
			}, true);

			scope.$watch('tCounty', function () {
				scope.disabled = true;
				scope.cities.list = [];
				scope.cities.text = null;
			}, true);


			$timeout(function () {
				if (!_.isNull(scope.tModel)) {
					scope.cities.text = scope.tModel.name;
					if (!_.isUndefined(scope.tModel.disabled)) {
						scope.disabled = scope.tModel.disabled;
					}
				}
			}, 200);


			scope.citySearch = function (query) {
				var deferred = $q.defer();
				var post = {name: query};
				if (!_.isUndefined(scope.tComunity) && !_.isNull(scope.tComunity)) {
					post.comunity_id = scope.tComunity.comunity_id;
				}
				if (!_.isUndefined(scope.tCounty) && !_.isNull(scope.tCounty)) {
					post.county_id = scope.tCounty.county_id;
				}
				if (!_.isUndefined(scope.tState) && !_.isNull(scope.tState) && scope.tState!="") {
					post.state = scope.tState;
				}
				$http.post('/teryt/street', post)
					.success(function (list) {
						scope.cities.list = list;
						deferred.resolve(scope.cities.list.filter(scope.createFilterFor(query)));
					});

				return deferred.promise;
			};

			scope.createFilterFor = function (query) {
				return function filterFn(item) {
					return (angular.lowercase(item.name).indexOf(angular.lowercase(query)) === 0);
				};
			};

		}
	};
});
